<app-modal 
  [open]="true" 
  [actions]="actions" 
  [highlightPrimaryAction]="true" 
  [size]="ModalSizes.Medium"
  (handleAction)="handleAction($event)">
  <heading 
    [icon]="IconTypes.Bucket" 
    [color]="UiColors.Blue">
    <h4 class="heading-title">Change Consignment</h4>
  </heading>

  <div class="modal-body">
    <div class="form-wrap">
      <div class="row">
        <input-field 
        *ngIf="consignmentDetails?.useCustomConsignments; else showDropdown" 
        [type]="'text'"
        (valueChanged)="consignmentValue = $event.trim()" 
        [autoComplete]="'new-name'" 
        [value]="consignmentValue"
        [label]="'Consignment'" >
        </input-field>

        <ng-template #showDropdown>
        <app-dropdown 
        [label]="'Consignment'" 
        [dropdownTheme]="'light'"
        [activeItem]="consignmentValue ? consignmentValue : 'No consignment'"
      >
        <div dropdownRef>
          <a class="dropdown-item" (click)="consignmentValue = null">No consignment</a>
          <a
            *ngFor="let value of consignmentDetails?.consignmentValues"
            class="dropdown-item"
            (click)="consignmentValue = value"
            >{{ value }}</a
          >
        </div>
      </app-dropdown>
      </ng-template>
      </div>
    </div>
  </div>

</app-modal>